import {
  Label,
  LabelValue,
  LabelType,
  LabelValueSource,
  LabelValueAcceptedBy
} from 'graphql/types';

export const filterLabelsByType = <T extends Label>(
  labels: T[],
  labelType: LabelType
): T[] => {
  return labels.filter((label: Label) => label.type === labelType);
};

export const isLabelType = <T extends Label>(
  label: T,
  labelType: LabelType
): boolean => label.type === labelType;

export const mapDefaultValue = (
  label: Label,
  defaultValue: undefined | null
): LabelValue | undefined | null => {
  if (!label || !label.defaultValue) return defaultValue;
  return {
    idValue: label.defaultValue?.idValue,
    stringValue: label.defaultValue?.stringValue,
    numericValue: label.defaultValue?.numericValue || null
  };
};

export const determineLabelAcceptedBy = (
  valueSource: LabelValueSource,
  acceptedBy: LabelValueAcceptedBy | null | undefined,
  isSmartSuggestionEnabled: boolean
): LabelValueAcceptedBy | null => {
  if (
    valueSource === LabelValueSource.User ||
    // Should we enforce accepted by user when suggestion off? If the user turns the setting off then we end up rewriting history for the label.
    !isSmartSuggestionEnabled
  ) {
    return LabelValueAcceptedBy.User;
  }
  return acceptedBy ?? null;
};

export const isSuggestion = (
  isSmartSuggestionEnabled: boolean,
  label:
    | {
        valueSource?: LabelValueSource | null;
        acceptedBy?: LabelValueAcceptedBy | null;
      }
    | undefined
    | null
): boolean => {
  return (
    isSmartSuggestionEnabled &&
    label?.valueSource === LabelValueSource.Suggestion &&
    !label?.acceptedBy
  );
};
